import { useContext } from 'react';
import { InternalSideSheetContext } from './content.es.js';

const useInternalSideSheetContext = ()=>{
    const context = useContext(InternalSideSheetContext);
    if (context == null) {
        throw new Error('InternalSideSheetContext should only be used within the InternalSideSheetContextProvider.');
    }
    return context;
};

export { useInternalSideSheetContext };
//# sourceMappingURL=index.es.js.map
